<script>
import appConfig from '@src/app.config'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<!-- This should generally be the only CSS in the app. -->
<style lang="scss">
// Design framework - TailwindCSS
@import '@tailwind';

// Customizations - must be very last import
@import 'design';

body,
html {
  height: 100%;
  background: #f1f5f9;
}

#app {
  display: flex;
  height: 100%;
}

.text-error {
  @apply text-red-500;
}

.border-error {
  @apply border-red-500;
}

.w-300 {
  width: 100%;
  max-width: 500px;
}

a {
  @apply cursor-pointer;

  color: #5850ec;
  border-bottom-color: #5850ec;
}
a:hover {
  border-style: solid;
  border-bottom-width: 1px;
}

.btn {
  @apply font-bold rounded text-center cursor-pointer uppercase block w-full transition duration-500;
}
.btn:disabled {
  @apply opacity-75;
}
.btn-main {
  @apply font-normal;

  color: #f0f5ff;
  background-color: #5850ec;
  border: 1px solid #5850ec;
}
.btn-main:hover {
  background-color: #4f47d4;
  border: 1px solid #4f47d4;
}
.btn-danger {
  @apply font-normal bg-red-500;

  color: #f0f5ff;
}
.btn-danger:hover {
  @apply bg-red-600;
}
.btn-secondary {
  @apply font-normal bg-blue-500;

  color: #f0f5ff;
}
.btn-secondary:hover {
  @apply bg-blue-600;
}

.input {
  @apply px-2 py-3;
}

.sidebar {
  position: sticky;
  top: 0;
  z-index: 200;
  flex: 1 0 auto;
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  background-color: #1a202e;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-duration: 0.4s;
  transition-property: margin-left, color;

  .sidebar-link {
    @apply block text-left transition duration-500 px-4 py-2 rounded border-none mb-2 text-base text-gray-400;

    &:hover {
      @apply bg-gray-800 border-none text-gray-100;
    }
  }

  svg {
    @apply text-lg;
  }

  .router-link-active {
    @apply bg-gray-800 border-none text-gray-100;
  }
}

.sidebar-icon {
  position: absolute;
  top: 5px;
  left: 10px;
  z-index: 100;
  width: 16px;
  height: 16px;
  font-size: 12px;
  color: #808080;
  cursor: pointer;

  &--expanded {
    left: 286px;
  }
}

.w-20 {
  width: 7rem;
}

.body {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
}

.table-auto {
  thead {
    background: #fbfdfe;

    th {
      @apply px-2 py-4 text-sm border-t border-b;

      white-space: nowrap;

      &:first-child {
        @apply pl-8;
      }

      &:last-child {
        @apply pr-8;
      }
    }
  }

  tbody {
    tr {
      &:hover {
        @apply bg-gray-100;
      }
    }

    td {
      @apply p-1 border-b;

      white-space: nowrap;

      &:first-child {
        @apply pl-8;
      }

      &:last-child {
        @apply pr-8;
      }
    }
  }
}

.modal {
  transition: opacity 0.25s ease;
}

body.modal-active {
  overflow-x: hidden;
  overflow-y: visible !important;
}

label {
  @apply block; // Fix Cypress error that element has width and height set to 0px
}

.datepicker {
  .mx-datepicker,
  .mx-datepicker-range {
    width: 100%;
  }

  .mx-input {
    height: auto;
    min-height: 39px;
    padding-top: 0.75rem;
    padding-right: 1rem;
    padding-bottom: 0.75rem;
    padding-left: 1rem;
    border-color: rgba(226, 232, 240, 1);
    border-radius: 0.375rem;
    box-shadow: none;
  }
}

@media print {
  .hide-on-print {
    display: none !important;
  }
}
</style>
